
import proxy from './proxy';


/**
 * @mixin Dialog or bar whose rendering may be retargeted to the application scope.
 */
export default {
    props: {
        /** @private */
        inline: Boolean
    },

    data() {
        return {
            key: 0,
            ivalue: false
        };
    },

    watch: {
        value: {
            handler(value) {
                if (this.ivalue != value) {
                    this.ivalue = value;
                    if (this.proxy_) {
                        (value ? this.capture : this.release)();
                    }
                }
            },
            immediate: true
        }
    },

    beforeCreate() {
        const options = this.$options;
        const host = window.__app;
        if (!host || options.propsData.inline) {
            this.proxy_ = this;
        } else {
            this.host = host;
            this.mounted = options.mounted;
            this.render = options.render;
            options.mounted = [];
            options.render = () => {};
        }
    },

    created() {
        const host = this.host;
        if (host) {
            host.child.push({
                is: proxy,
                key: this._uid,
                attrs: {
                    hosted: this
                }
            });
        }
    },

    beforeDestroy() {
        const host = this.host;
        if (host) {
            Vue.delete(host.child, host.child.findIndex(e => e.key === this._uid));
        }
    },

    updated() {
        // referenced by proxy render function to propagate reactivity
        this.key++;
    },

    methods: {
        // vue 2 does not include class in $attrs; propagate it manually
        classAttrs(name) {
            const staticClass = Vue.version.startsWith(2) ? this.$vnode.data.staticClass : 0;
            return staticClass ? name + ' ' + staticClass : name;
        }
    }
}
